/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WcMaxValueRequest } from '../../models/wc-max-value-request';
import { WcMaxValueResponse } from '../../models/wc-max-value-response';

export interface ApiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost$Params {
      body: WcMaxValueRequest
}

export function apiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost(http: HttpClient, rootUrl: string, params: ApiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost$Params, context?: HttpContext): Observable<StrictHttpResponse<WcMaxValueResponse>> {
  const rb = new RequestBuilder(rootUrl, apiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WcMaxValueResponse>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
apiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost.PATH = '/api/CT/CoolingSystem/GetWcMaxValuesWithLastUpdatedDateTime';
apiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost.METHOD = 'post';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
apiCtCoolingSystemGetWcMaxValuesWithLastUpdatedDateTimePost.ROOTURL = '/cooling';
